import { combineReducers } from 'redux';
import { amendTradeReducerFactory } from 'state/secondaryMarket/shared/amend/amend.reducer';
import { cancellationReducerFactory } from 'state/secondaryMarket/shared/cancellation/cancellation.reducer';

import type { CpOrder } from './cpOrder.model';
import { cpOrderFormDataReducer } from './cpOrderForm/cpOrderForm.reducer';
import { orderReducer } from './order/order.reducer';
import { cpOrderReferentialReducer } from './referential/referential.reducer';

export const cpOrderReducer = combineReducers<CpOrder>({
  form: cpOrderFormDataReducer,
  order: orderReducer,
  amend: amendTradeReducerFactory('CP_ORDER'),
  referential: cpOrderReferentialReducer,
  cancellations: cancellationReducerFactory('CP_ORDER'),
});
